import { getAuth } from "firebase/auth";

export const getCurrentUserId = async (): Promise<string | null> => {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error("User not found");
  return currentUser.uid;
};